import styled from 'styled-components';

// Render the Profile sub-components at the native iPhone viewport width so they
// hit the same mobile breakpoints as the real /p/:token page, then `zoom` the
// whole tree down to fit our phone frame. Unlike `transform: scale`, `zoom`
// scales both visual and layout dimensions — so native overflow scrolling
// still works inside the phone (which `transform: scale` breaks).
const MOBILE_VIEWPORT_WIDTH_PX = 414;
const DESKTOP_PHONE_INNER_WIDTH_PX = 310;
const MOBILE_PHONE_INNER_WIDTH_PX = 240;
const DESKTOP_ZOOM = DESKTOP_PHONE_INNER_WIDTH_PX / MOBILE_VIEWPORT_WIDTH_PX;
const MOBILE_ZOOM = MOBILE_PHONE_INNER_WIDTH_PX / MOBILE_VIEWPORT_WIDTH_PX;

export const FrameWrap = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 3rem;
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
`;

export const ScrollableArea = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: ${({ theme }) => theme.colors.white};

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ZoomedViewport = styled.div`
  width: ${MOBILE_VIEWPORT_WIDTH_PX}px;
  zoom: ${DESKTOP_ZOOM};

  @media (max-width: 768px) {
    zoom: ${MOBILE_ZOOM};
  }
`;
